import { Box, Column, Columns, Tabs } from "@allxsmith/bestax-bulma";
import React from "react";
import Figure from "../Homepage/Figure";
import FilterHeading from "../Invoicing/FilterHeading";
import axios from "axios";
import {useDispatch} from "react-redux";
import {createSetDataFreshAction, createSetRentalsDataAction} from "../../actions/dataActions";
import VehicleRentalRow from "./VehicleRentalRow";
import {ToastContainer, toast} from "react-toastify";

export default function VehicleRentalView(props) {
  const dispatch = useDispatch();

  const dateFields = [
    "data_of_quote_received"
  ];

  const fixEmptyDates = rental => {
    dateFields.forEach(function (date) {
      if (rental[date] === "") {
        rental[date] = null;
      }
    });
    return rental;
  };

  const onVehicleSave = (index) => {
        // this needs to send a request to the qc endpoint
        const conf = {
            url: "api/vehicles/qc",
            data: props.rentals[index].vehicle,
            method: "put"
        }

        axios(conf).then(res => {
            dispatch(createSetDataFreshAction(props.dataFresh + 1));
        }).catch(err => {
            toast.error("There was an error saving vehicle", {position: "top-right"});
        })
    }

    const onRentalSave = (index) => {
      let data = props.rentals.results[index]
      data = fixEmptyDates(data);
      const conf = {
          url: `/api/rentals/${data.id}`,
          method: "put",
          data: data
      }
      axios(conf).then(res => {
          dispatch(createSetDataFreshAction(props.dataFresh + 1))
      }).catch(err => {
          toast.error("There was an error saving rental", {position: "top-right"});
      })
    }

    const onChange = (e, index) => {
        let newState = {...props.rentals};
        let newResults  = [...props.rentals.results]
        let newRental = {...props.rentals.results[index], [e.target.name]: e.target.value};
        newResults[index] = newRental;
        newState.results = newResults
        dispatch(createSetRentalsDataAction(newState));
    }

    const onMultiFieldChange = (data, index) => {
      let newResults = [...props.rentals.results];
      let newState = {...props.rentals, results: newResults};
      let newRental = {...props.rentals.results[index]};
      for (const [key, value] of Object.entries(data)) {
          // loop through all key value pairs of passed data
          // assign them to new rental
          newRental[key] = value;
      }
      newState.results[index] = newRental;
      dispatch(createSetRentalsDataAction(newState));
    }

    const onQcCheck = (e, index) => {
        let newResults = [...props.rentals.results];
        let newState = {...props.rentals, results: newResults};
        let newRental = {...props.rentals.results[index]}
        let newVehicle = {...newRental.vehicle};
        newVehicle[e.target.name] = !newRental.vehicle[e.target.name];
        newRental.vehicle = newVehicle;

        newState.results[index] = newRental;
        dispatch(createSetRentalsDataAction(newState));
    }



    return (
      <Box>
        <h1 className="title">Rentals{props.dateRangeString ? props.dateRangeString : ""}</h1>
        <Tabs fullwidth align={"centered"} toggle>
          <Tabs.List>
            {props.view === "weekly" && props.dayInput}
            <Column></Column>
            <Column></Column>
            <Column></Column>
          </Tabs.List>
        </Tabs>
        <Columns isMultiline>
            <Column>
                <Figure label="Total Estimated Long Term Weekly Rate" value={props.total_long_term} loaded={props.total_long_term}/>
            </Column>
            <Column>
                <Figure label="Total Estimated Short Term Weekly Rate" value={props.total_short_term} loaded={props.total_short_term}/>
            </Column>
        </Columns>
        <Tabs align="centered" toggle>
          <Tabs.List>
            <Tabs.Item active={props.view === "all"}><a onClick={() => props.onViewChange("all")}>All
                        </a></Tabs.Item>
            <Tabs.Item active={props.view === "all_hire"}><a onClick={() => props.onViewChange("all_hire")}>All On Hire
                        </a></Tabs.Item>
            <Tabs.Item active={props.view === "weekly"}><a onClick={() => props.onViewChange("weekly")}>Weekly
                        </a></Tabs.Item>
            <Tabs.Item active={props.view === "onhires"}><a onClick={() => props.onViewChange("onhires")}>Upcoming Onhires
                        </a></Tabs.Item>
            <Tabs.Item active={props.view === "offhires"}><a onClick={() => props.onViewChange("offhires")}>Upcoming Offhires
                        </a></Tabs.Item>
            <Tabs.Item active={props.view === "insurance"}><a onClick={() => props.onViewChange("insurance")}>Insurance Expiries
                        </a></Tabs.Item>
            <Tabs.Item active={props.view === "unfinished_off"}><a onClick={() => props.onViewChange("unfinished_off")}>Unfinished Offhires
                        </a></Tabs.Item>
            <Tabs.Item active={props.view === "awaiting_quote"}><a onClick={() => props.onViewChange("awaiting_quote")}>Awaiting Estimate
                        </a></Tabs.Item>
            <Tabs.Item active={props.view === "over_mileage"}><a onClick={() => props.onViewChange("over_mileage")}>Over Mileage
                        </a></Tabs.Item>
            <Tabs.Item active={props.view === "quotes"}><a onClick={() => props.onViewChange("quotes")}>Quotes
                        </a></Tabs.Item>
            <Tabs.Item active={props.view === "nr"}><a onClick={() => props.onViewChange("nr")}>Not Required
                        </a></Tabs.Item>
          </Tabs.List>
        </Tabs>
        <table className="table is-hoverable is-fullwidth is-striped">
          <thead>
          <tr>
            <th>ID</th>
            <FilterHeading
                key={"vehicle__registration"}
                heading={{label: "Registration", field: "vehicle__registration", labelField: "vehicle__registration"}}
                setFilters={f => {
                    props.onPageChange(1);
                    props.setFilters(f);
                }}
                filters={props.filters}
                options={props.filterList.vehicle__registration}
            />
            <FilterHeading
              key='rental_type'
              heading={{label: "Type", field: "rental_type", labelField: "rental_type"}}
              setFilters={f => {
                props.onPageChange(1);
                props.setFilters(f);
              }}
              filters={props.filters}
              options={props.filterList.rental_type}
            />
            <th>Tracker Hire</th>
            <FilterHeading
              key='chargeable_date'
              heading={{date: true, label: "Start Date", field: "chargeable_date", labelField: "chargeable_date"}}
              setFilters={f => {
                props.onPageChange(1);
                props.setFilters(f);
              }}
              filters={props.filters}
              options={props.filterList.chargeable_date}
            />
            <FilterHeading
              key='end_date'
              heading={{date: true, label: "End Date", field: "finish_date", labelField: "finish_date"}}
              setFilters={f => {
                props.onPageChange(1);
                props.setFilters(f);
              }}
              filters={props.filters}
              options={props.filterList.finish_date}
            />
            <FilterHeading
              key='customer'
              heading={{label: "Customer", field: "customer", labelField: "customer__display_name"}}
              setFilters={f => {
                props.onPageChange(1);
                props.setFilters(f);
              }}
              filters={props.filters}
              options={props.filterList.customer}
            />
            <FilterHeading
              key='make'
              heading={{label: "Make", field: "vehicle__make", labelField: "vehicle__make__name"}}
              setFilters={f => {
                props.onPageChange(1);
                props.setFilters(f);
              }}
              filters={props.filters}
              options={props.filterList.make}
            />
            <FilterHeading
              key='model'
              heading={{label: "Model", field: "vehicle__model", labelField: "vehicle__model__name"}}
              setFilters={f => {
                props.onPageChange(1);
                props.setFilters(f);
              }}
              filters={props.filters}
              options={props.filterList.model}
            />
              <FilterHeading
              key='type'
              heading={{label: "Type", field: "vehicle__type", labelField: "vehicle__type__name"}}
              setFilters={f => {
                props.onPageChange(1);
                props.setFilters(f);
              }}
              filters={props.filters}
              options={props.filterList.type}
            />
            {props.view !== "awaiting_quote" && <th>Daily Rate</th>}
            {props.view !== "awaiting_quote" && <th>Daily Finance Payment</th>}
            {props.view !== "awaiting_quote" && <th>Rate Card</th>}
            {props.view !== "awaiting_quote" && <th>Invoice Interval</th>}
            <th>Comments</th>
            {props.view === "unfinished_off" && <th>Off Hire Comments</th>}
            {props.view === "unfinished_off" && <th>Missing Items</th>}
            {props.view === "awaiting_quote" && <th>Damage Indicated Date</th>}
            {props.view === "awaiting_quote" && <th>Quote Received</th>}
            {props.view === "awaiting_quote" && <th>Quote Received Date</th>}
            {props.view === "awaiting_quote" && <th>Quote Amount</th>}
            <th>Qc Check</th>
          </tr>
          </thead>
          <tbody>
          {props.rentals.results.map((value, index) => (
              <VehicleRentalRow
                value={value}
                index={index}
                onChange={onChange}
                onQcCheck={onQcCheck}
                onVehicleSave={onVehicleSave}
                onRentalSave={onRentalSave}
                view={props.view}
                getMissingOffHireItems={props.getMissingOffHireItems}
                onMultiChange={onMultiFieldChange}
              />
          ))}
          </tbody>
        </table>
        {/*<Pagination*/}
        {/*  showFirstLast={true}*/}
        {/*  onChange={page => props.onPageChange(page)}*/}
        {/*  current={props.current}*/}
        {/*  total={Math.ceil(props.count / 25)}*/}
        {/*/>*/}
      </Box>
    );
}
